import React from 'react';
import { AccountSettings } from 'src/sections';

function AccountSettingsPage(props) {
    return <AccountSettings />;
}

export default AccountSettingsPage;